import { render } from "./Popper.vue?vue&type=template&id=acf7daa6&scoped=true"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"

import "./Popper.vue?vue&type=style&index=0&id=acf7daa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf7daa6"]])

export default __exports__